import { createStore } from 'vuex';
import cartHelpers from './api';
const { status, fetch, fetchInventory, add, update, change, updateNote, clear } = cartHelpers;
const req = (api, data) => {
  return new Promise(resolve => {
    api(data).then(data => {
      resolve(data);
    });
  });
};

const afterReq = (data, commit, getters) => {
  commit('setCart', data);

  const _status = getters.cartItems.length ? status.ideal : status.empty;
  commit('setStatus', _status);
};


export default createStore({
  state: {
    cart: {},
    inventory: [],
    status: status.empty,
    updateIds: [],
    updateLine: 0,
  },

  getters: {
    isCartReady: state => [status.ideal, status.empty].includes(state.status),
    cartItems: state => state.cart.items || []
  },

  mutations: {
    setCart(state, cart) {
      state.cart = cart;
    },

    addCartItem(state, items) {
      state.cart.items.splice(0, 0, ...items);
    },

    setInventory(state, inventory) {
      state.inventory = inventory
    },

    setUpdateIds(state, ids) {
      state.updateIds = ids;
    },

    setStatus(state, status) {
      state.status = status;
    },
    
    setUpdateLine(state, lines) {
      state.updateLine = lines;
    },
  },

  actions: {
    async init({ commit, getters }, s1 = status.progress) {
      await commit('setStatus', s1);
      await req(fetchInventory).then(inventory => commit('setInventory', inventory));
      await req(fetch).then(data => afterReq(data, commit, getters));
      return true;
    },

    add({ commit, dispatch, getters }, data) {
      if (getters.isCartReady) {
        commit('setStatus', status.adding);
        return req(add, data).then(() => dispatch('init', status.adding));
      }
    },

    change({ commit, getters }, data) {
      const { noStateUpdate, cb } = data
      delete data.cb
      if (getters.isCartReady || noStateUpdate) {
        if(!noStateUpdate) {
          commit('setUpdateLine', data.line);
          commit('setStatus', status.progress);
        }else delete data.noStateUpdate
        
        return req(change, data).then(data => {
          afterReq(data, commit, getters);
          !noStateUpdate && commit('setUpdateLine', 0);
          cb && cb()
          return data; // Return the data so it can be used in .then()
        });
      }
    },

    changeThenAdd({ commit, getters, dispatch }, payload) {
      if (getters.isCartReady) {
        if (payload.line) {
          commit('setUpdateLine', payload.line);
        }
        commit('setStatus', status.progress);

        // Step 1: Process all change operations sequentially
        const processChanges = async () => {
          for (let i = 0; i < payload.change.length; i++) {
            await req(change, payload.change[i]);
          }
        };

        // Step 2: Process add operations after all changes are complete
        return processChanges().then(() => {
          if (payload.add?.length > 0) {
            return req(add, payload.add).then(() => dispatch('init', status.progress));
          }
        }).catch(err => {
          console.error("changeThenAdd failed:", err);
        });
      }
    },

    changeThenAdd({ commit, getters, dispatch }, payload) {
      if (getters.isCartReady) {
        if (payload.line) {
          commit('setUpdateLine', payload.line);
        }
        commit('setStatus', status.progress);

        // Step 1: Process all change operations sequentially
        const processChanges = async () => {
          for (let i = 0; i < payload.change.length; i++) {
            await req(change, payload.change[i]);
          }
        };

        // Step 2: Process add operations after all changes are complete
        return processChanges().then(() => {
          if (payload.add?.length > 0) {
            return req(add, payload.add).then(() => dispatch('init', status.progress));
          }
        }).catch(err => {
          console.error("changeThenAdd failed:", err);
        });
      }
    },

    async update({ commit,dispatch, getters }, data) {
      if (getters.isCartReady) {
        await commit('setUpdateLine', data.line);
        await commit('setStatus', status.progress);
        await req(update, data.data).then(async () => {
          await dispatch('init', status.progess);
        });
        return true;
      }
    },

    updateNote({ commit, getters }, note) {
      if (getters.isCartReady) {
        commit('setStatus', status.progress);
        req(updateNote, note).then(data => afterReq(data, commit, getters));
      }
    },

    clear({ commit, getters }) {
      if (getters.isCartReady) {
        commit('setStatus', status.progress);
        req(clear).then(data => afterReq(data, commit, getters));
      }
    }
  }
});